var deviceAgent = navigator.userAgent.toLowerCase()
var agentID = deviceAgent.match(/(iphone|ipod|ipad)/)

if (agentID) {
	document.body.classList.add('ios')
}
